<div *ngIf="companyOverviewSummaryGraphFG" class="row mt-2">
  <div class="col-xl-8 col-12">
    <form #form="ngForm" [formGroup]="companyOverviewSummaryGraphFG">
      <div class="row">
        <div class="col mb-2 padding-cha-r">
          <kendo-dropdownlist
            formControlName="comparisonCompany"
            [defaultItem]="{ companyName: 'Compare with Company', id: null }"
            [data]="filteredCompanyList"
            textField="companyName"
            [filterable]="true"
            (filterChange)="handleCompanyFilter($event)"
            valueField="id"
          >
          </kendo-dropdownlist>
        </div>
        <div class="col mb-2 padding-cha-l">
          <kendo-dropdownlist
            formControlName="comparisonIndex"
            [defaultItem]="{ name: 'Compare with Index', id: null }"
            [data]="chartIndexTypes"
            textField="name"
            [filterable]="true"
            (filterChange)="handlecomparisonIndexFilter($event)"
            valueField="name"
          >
          </kendo-dropdownlist>
        </div>
      </div>
    </form>
  </div>
  <div class="col-xl-4 col-12">
    <div class="duration-selection">
      <ul>
        <li (click)="durationChanged('1W')" class="{{ selectedDuration === '1W' ? 'active' : '' }}">1W</li>
        <li (click)="durationChanged('1M')" class="{{ selectedDuration === '1M' ? 'active' : '' }}">1M</li>
        <li (click)="durationChanged('6M')" class="{{ selectedDuration === '6M' ? 'active' : '' }}">6M</li>
        <li (click)="durationChanged('1Y')" class="{{ selectedDuration === '1Y' ? 'active' : '' }}">1Y</li>
        <!--        <li (click)="durationChanged('3Y')" class="{{ selectedDuration === '3Y' ? 'active' : '' }}">3Y</li>-->
        <!--        <li (click)="durationChanged('5Y')" class="{{ selectedDuration === '5Y' ? 'active' : '' }}">5Y</li>-->
      </ul>
    </div>
  </div>
</div>
<div class="selected-graphs">
  <ul>
    <li *ngFor="let graphItem of selectedGraphs">
      {{ graphItem?.type ? graphItem.name : graphItem.companyName }}
      <span class="remove" (click)="removeSelectedGraph(graphItem)">&times;</span>
    </li>
  </ul>
</div>
<div id="wrapper">
  <div id="chart-line">
    <div class="dotted-loader" [hidden]="graphDataSet?.length !== 0"></div>
    <!--    <apx-chart-->
    <!--      *ngIf="selectedCompany && companyList && chartIndex && sharePrice && graphDataSet?.length > 0"-->
    <apx-chart
      *ngIf="selectedCompany && companyList && graphDataSet?.length > 0"
      [series]="chartOptions1?.series"
      [chart]="chartOptions1?.chart"
      [xaxis]="chartOptions1?.xaxis"
      [yaxis]="chartOptions1?.yaxis"
      [legend]="chartOptions1?.legend"
      [dataLabels]="chartOptions1?.dataLabels"
      [fill]="chartOptions1?.fill"
      [markers]="chartOptions1?.markers"
      [stroke]="chartOptions1?.stroke"
      [grid]="chartOptions1?.grid"
      [tooltip]="chartOptions1?.tooltip"
    ></apx-chart>
  </div>
</div>
